import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";

type PhoneNumberAuthenticationModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
};
export const PhoneNumberAuthenticationModal = ({ open, setOpen }: PhoneNumberAuthenticationModalProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden py-8 w-[350px] md:w-[450px] h-[357x] ring-0 ring-transparent">
        <DialogTitle className="text-black text-center font-Inter text-[20px] font-semibold leading-[30px] mx-auto">
          電話番号の認証が必要です
        </DialogTitle>

        <div className="text-dark-gray text-center text-base mt-2">
          無料ポイント獲得機能や出金機能をご利用いただくには、電話番号の認証が必要です。
        </div>

        <div className="flex flex-col w-full items-center justify-center mt-4">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
            variant="default"
            onClick={() => navigate("/sms-registration")}
          >
            電話番号の認証をする
          </Button>
          <Button
            className="text-base mt-3 underline font-normal"
            variant="link"
            onClick={() => {
              setOpen(false);
            }}
          >
            閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
